import { ISubPage } from "../../data/Data";

// subPages is addressed by array index elsewhere (EditSectionsItemsPagesPage reads
// subPages[idSubPage] directly), so the "page id" a route needs is just that index.
export function findEditSubItemPageId(subPages: ISubPage[] | undefined, fieldId: number): number | undefined {
  if (!subPages) return undefined;
  const index = subPages.findIndex((subPage) => subPage.type === "editSubItem" && subPage.fieldId === fieldId);
  return index === -1 ? undefined : index;
}
